import React from 'react';
import { BrandColor } from '@styleseat/brand';

type BasicSearchIconProps = {
  width?: number;
  height?: number;
  color?: string;
  shadow?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  sparkles?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const BasicSearchIcon = ({
  width = 24,
  height = 24,
  viewBox = '9 0 24 34',
  color = BrandColor.BackInBlack,
  shadow = false,
}: BasicSearchIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {shadow && (
      <React.Fragment>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1994 25.6517C15.0519 25.6517 10.0684 20.6682 10.0684 14.5208C10.0684 8.37333 15.0519 3.38983 21.1994 3.38983C27.3468 3.38983 32.3303 8.37333 32.3303 14.5208C32.3303 17.093 31.4578 19.4615 29.9926 21.3463L37.4883 28.842L35.5206 30.8097L28.0249 23.314C26.1401 24.7792 23.7716 25.6517 21.1994 25.6517ZM29.5476 14.5208C29.5476 19.1314 25.81 22.869 21.1994 22.869C16.5888 22.869 12.8512 19.1314 12.8512 14.5208C12.8512 9.91019 16.5888 6.17257 21.1994 6.17257C25.81 6.17257 29.5476 9.91019 29.5476 14.5208Z"
          fill={BrandColor.BlueHighlight}
        />
        <circle
          cx="21.25"
          cy="14.5714"
          r="10.3214"
          fill={BrandColor.BlueHighlight}
        />
      </React.Fragment>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1637 25.0446C12.0162 25.0446 7.03271 20.0611 7.03271 13.9137C7.03271 7.76621 12.0162 2.78271 18.1637 2.78271C24.3111 2.78271 29.2946 7.76621 29.2946 13.9137C29.2946 16.4859 28.4221 18.8544 26.9569 20.7392L34.4526 28.2349L32.4849 30.2026L24.9892 22.7069C23.1044 24.1721 20.7359 25.0446 18.1637 25.0446ZM26.5119 13.9137C26.5119 18.5243 22.7743 22.2619 18.1637 22.2619C13.5531 22.2619 9.81545 18.5243 9.81545 13.9137C9.81545 9.30308 13.5531 5.56545 18.1637 5.56545C22.7743 5.56545 26.5119 9.30308 26.5119 13.9137Z"
      fill={color}
    />
  </svg>
);
